import * as React from 'react';

import { UitkIcon } from 'uitk-react-icons';
import { IconAndLabelType } from 'src/types/shared';

export interface AmenityProps {
  amenity: IconAndLabelType;
}

export const Amenity = ({ amenity }: AmenityProps) => (
  <li role="listitem" aria-label={amenity.accessibility}>
    <div aria-hidden={true}>
      <UitkIcon id={amenity.icon.id} name={amenity.icon.id} description={amenity.icon.description} />
      <span>{amenity.label}</span>
    </div>
  </li>
);
